import { useSelector } from "react-redux";
import { RightArrowIcon } from "staysure-component-library";

import ButtonWrapper from "@/app/shared-components/button-wrapper/button-wrapper";
import { RootState } from "@/store/root-reducer";

import { useContactDetailsContext } from "../../../provider/contact-details.provider";
import { descriptionSectionCmsData } from "../../../utils/contact-details-page.util";

function ContactDetailsSupportSectionButton() {
  const { isFilled } = useSelector((state: RootState) => state.contactDetails);
  const { cmsData } = useContactDetailsContext();

  const { ctaLabel, isOpenInNewtab, isButtonVisible, ctaUrl } =
    descriptionSectionCmsData(cmsData);

  const URLOpenNewTab = () => {
    const url = ctaUrl;
    if (isOpenInNewtab) {
      const win = window.open(url, "_blank");
      win?.focus();
    } else {
      window.location.href = url;
    }
  };

  // Check if the button should be visible and if the form is not filled
  return (
    isButtonVisible &&
    !isFilled && (
      <div className=" text-dark-text-title text-[18px] font-semibold leading-[18px] mt-spacing-m">
        <ButtonWrapper
          id="contact-support-cta"
          hierarchy="tertiary"
          label={ctaLabel}
          isRightIcon
          rightIcon={<RightArrowIcon />}
          semanticColor="Dark Background"
          className="text-[18px] font-semibold leading-[18px]"
          onClick={URLOpenNewTab}
        />
      </div>
    )
  );
}
export default ContactDetailsSupportSectionButton;
